<div [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom">
  <eds-banner-multi-promo
    *ngIf="promoCards && promoCards.length > 0 && !displaySidebar"
    [promoCards]="promoCards"
    [promoSlots]="promoCards?.length"
    [signInTooltip]="'common.locked-link-tooltip' | translate"
  ></eds-banner-multi-promo>
  <eds-banner-multi-promo-link-list
    *ngIf="promoCards && promoCards.length && displaySidebar"
    [linkListTitle]="sidebarContent?.linkListTitle"
    [linkListDescription]="sidebarContent?.linkListDescription"
    [linkListItems]="sidebarContent?.linkListItems"
    [linkListDetails]="displaySidebar"
    [mainPromoDetails]="promoCards[0]"
    [singlePromo]="true"
  ></eds-banner-multi-promo-link-list>
</div>
